import { useQueryClient } from "@tanstack/react-query";
import type { Org } from "@/libs/onboardingApi";
import { FinanceAccountSetup } from "@/components/payments/FinanceAccountSetup";

export function StripeConnectPanel({ orgId }: { org: Org; orgId: string }) {
  const cache = useQueryClient();
  return <FinanceAccountSetup key={orgId} orgId={orgId} onChanged={() => {
    void cache.invalidateQueries({ queryKey: ["org", orgId, "onboarding-state"] });
    void cache.invalidateQueries({ queryKey: ["org", "me"] });
  }} />;
}
